import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getVideos, getVideo, deleteVideo } from '@/services/videoApi';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to fetch all videos.
 * Query key includes user.id to isolate caches when users switch accounts.
 * Query is disabled when unauthenticated (no user.id).
 */
export function useVideos() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['videos', user?.id],
    queryFn: getVideos,
    enabled: !!user?.id,
  });
}

/**
 * Hook to fetch a single video
 */
export function useVideo(videoId: string | undefined) {
  return useQuery({
    queryKey: ['videos', videoId],
    queryFn: () => getVideo(videoId!),
    enabled: !!videoId,
  });
}

/**
 * Hook to delete a video
 */
export function useDeleteVideo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteVideo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['videos'] });
    },
  });
}
